<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="microdata">
    <ItemCommonDescription
      :data-card="dataCard"
      :data-values="dataValues"
      :data-table-file="dataTableFile"
      :data-file-info="dataFileInfo"
      @change-detail-table="changeDetailTableInfo"
      @reload-data-card="reloadDataCard"
    />
    <div v-if="dataValues" class="years-wrapper has-side-bars">
      <ul class="years-list">
        <li
          v-for="year in yearsAvailable"
          :key="year"
          class="years-item"
          :class="{ selected: selectedYear === year }"
          @click="toggleSelectedYear(year)"
        >
          <div class="year-number">{{ year === 'other' ? $t('data_and_resources') : year }}</div>
          <div class="year-line" />
        </li>
      </ul>
    </div>
    <div v-if="dataValues">
      <div v-for="file in filesForYears[selectedYear]" :key="file.id">
        <DropDownFile
          :data-info="file"
          :data-api="file.format === 'CSV'"
          :data-table-file="dataTableFile"
          :file-id="file.id"
          @change-detail-table-info="changeDetailTableInfo"
        />
      </div>
    </div>
    <ItemViews :views="dataCard.popularity" />
    <ItemsRelated :card-id="dataCard.id" />
  </div>
</template>

<script>
import DropDownFile from './DropDownFile.vue'
import ItemViews from './ItemViews'
import { t } from '../../i18n/index'
import ItemCommonDescription from './ItemCommonDescription.vue'
import ItemsRelated from './ItemsRelated'
/**
 * Micro Data view disposition
 * @example [none]
 */
export default {
  name: 'MicroDataItem',
  components: {
    DropDownFile,
    ItemViews,
    ItemCommonDescription,
    ItemsRelated,
  },
  props: {
    /**
     * Item object information getted from api
     */
    dataCard: {
      type: Object,
    },
    /**
     * Item object information getted from opendata-ajuntament
     */
    dataValues: {
      type: Object,
    },
  },
  data() {
    return {
      dataTableFile: [],
      selectedYear: '',
      dataFileInfo: {},
    }
  },
  computed: {
    yearsAvailable() {
      if (this.dataValues) {
        let yearsArray = []
        let currentYear
        this.dataValues.resources.forEach(element => {
          currentYear = element.name.slice(0, 4)
          if (!parseInt(currentYear)) {
            currentYear = 'other'
          }
          //currentYear = dayjs(element.created).format('YYYY')
          if (yearsArray.indexOf(currentYear) === -1) {
            yearsArray.push(currentYear)
          }
        })
        let ordArray = yearsArray.sort(function (a, b) {
          return b - a
        })
        // if (ordArray.indexOf('other') !== -1) {
        //   ordArray.shift()
        //   ordArray.push('other')
        // }
        return ordArray
      } else return null
    },
    filesForYears() {
      if (this.dataValues) {
        let objectFiles = {}
        let currentYear
        this.dataValues.resources.forEach(element => {
          currentYear = element.name.slice(0, 4)
          if (!parseInt(currentYear)) {
            currentYear = 'other'
          }
          if (!objectFiles[currentYear]) objectFiles[currentYear] = []
          objectFiles[currentYear].push(element)
        })
        return objectFiles
      } else return null
    },
  },
  watch: {
    yearsAvailable() {
      this.selectedYear = this.yearsAvailable[0]
    },
  },
  mounted() {
    this.selectedYear = this.yearsAvailable ? this.yearsAvailable[0] : null
  },
  methods: {
    reloadDataCard() {
      this.$emit('reload-data-card')
    },
    /**
     * Toggles the selected year with given value
     * @param {Number} value The new value of the array of years selected
     * @public This is a public method
     */
    toggleSelectedYear(value) {
      this.selectedYear = value
    },
    /**
     * Change the information of table details and open the modal
     * @param {Object} file information of file clicked
     * @public This is a public method
     */
    changeDetailTableInfo(file) {
      let tableInfo = []
      //FORMAT
      tableInfo.push({
        camp_name: t('det_format'),
        description: file.format,
      })
      //LICENSE
      tableInfo.push({
        camp_name: t('license'),
        description: this.dataCard.license,
      })
      //GRAU D'OBERTURA
      tableInfo.push({
        camp_name: t('det_open_freq'),
        description: file.qa.opennessScoreReason,
      })
      //DATA PUBLICACIÓ
      tableInfo.push({
        camp_name: t('det_publish_date'),
        description: file.created,
      })
      //ULTIMA MODIFICACIO
      tableInfo.push({
        camp_name: t('det_last_update'),
        description: file.lastModified,
      })
      //MAPA VIEW
      tableInfo.push({
        camp_name: t('det_map_view'),
        description: file.mapVisualizationRes,
      })
      //TOKEN
      tableInfo.push({
        camp_name: t('det_req_token'),
        description: file.isTokenRequired,
      })
      //DOWNLOAD ID
      tableInfo.push({
        camp_name: t('det_downloads'),
        description: file.downloads,
      })
      //TOTAL DOWNLOAD
      tableInfo.push({
        camp_name: t('det_downloads_abs'),
        description: file.downloadsAbsolute,
      })
      this.dataTableFile = tableInfo
      //GRJ2EE-8911 (Añadido el id para referenciar el documento) 
      this.dataFileInfo = { name: file.name, url: file.url, id: file.id }
    },
  },
}
</script>

<style lang="stylus" scoped>
.years-wrapper
  position: relative

.years-list
  display: flex
  align-items: center
  overflow-x: auto
  overflow-y: hidden
  margin-top: vw(-75px)
  height: vw(75px)
  gap: vw(40px)

.years-item
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  list-style-type: none
  cursor: pointer

  &:hover
    .year-number
      color: $black

  &.selected
    cursor: default

    .year-number
      color: $black

    .year-line
      display: block

.year-number
  m-font-size(30, 40)
  color: $grey
  font-weight: 300

  .mobile &
    m-font-size(24, 28)

.year-line
  display: none
  width: 1px
  height: vw(30px)
  border-right: 1px solid $corporate_color
</style>
